module.exports = __webpack_public_path__ + "img/photo-veroniquelesourd-accueil-03.9d08af43.jpeg";